import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { getHomeOverview } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import CustomTable from "../../Common/DataTable/DataTable";

export default function OverView() {
  const { id, partnerId } = useParams();

  const [overview, setOverview] = useState([]);
  const [isLoading, setIsLoading] = useState(true);


  const fetchOverviewData = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }

    try {
      const response = await getHomeOverview(id);
      setOverview(response.data.data[0]);
      console.log(response.data.data[0]);
      console.log(id);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOverviewData();
  }, [id]);

  const columns = ["Icon number", "Icon", "Icon title"];
  const rows = [];

  if (overview && Object.keys(overview).length > 0) {
    rows.push([
      "Icon 1",
      overview.icon1 ? <img src={overview.icon1} alt="logo 1" width="150"/> : null,
      overview.name1
    ]);
    rows.push([
      "Icon 2",
      overview.icon2 ? <img src={overview.icon2} alt="logo 2" width="150"/> : null,
      overview.name2
    ]);
    rows.push([
      "Icon 3",
      overview.icon3 ? <img src={overview.icon3} alt="logo 3" width="150"/> : null,
      overview.name3
    ]);
    rows.push([
      "Icon 4",
      overview.icon4 ? <img src={overview.icon4} alt="logo 4" width="150"/> : null,
      overview.name4
    ]);
  }

  return (
  <>
    {isLoading ? <CmsCircularProgress/> : 
    <ContentWrapper>
      <HomeTitle>Service Overview Section</HomeTitle>
      <CustomTable
        columns={columns}
        rows={rows}
        isLoading={isLoading}
      />
      <ButtonWrapper>
        <Link to={`/${partnerId}/home`}>
          <Button variant="secondary">Go Back</Button>
        </Link>
        <Link to={`/${partnerId}/home/overview/edit/${id}`}>
          <Button>{Number(id) ? 'Edit' : 'Add'} Overview Section</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper>}
  </>
  );
}

const ContentWrapper = styled.div`
  @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 5rem;
  justify-content: center;
    @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
    gap: 1rem;
  }
`;
